import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import HomepageHeaderNav from './HomepageHeaderNav'; // @ts-expect-error FIXME

import backgroundLogo from 'bender-url!../../../../images/connect-logo-bg-homepage-header.svg';
import { useContext } from 'react';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import { buildLink } from 'connect-dot-com-ui-components/utils/urls';
import CUIConnectLogo from 'connect-dot-com-ui-components/Components/CUIConnectLogo/CUIConnectLogo';
import LoginSignupButtons from '../../LoginSignupButtons';

const HomepageHeader = ({
  children
}) => {
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsxs(CUIBox, {
    padding: {
      base: 8,
      sm: 10
    } // width="100%"
    ,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "105%",
    style: {
      backgroundImage: `url('${backgroundLogo}'), linear-gradient(106.61deg, #F8E1EC 0%, #FDF3F3 100%)`
    },
    children: [/*#__PURE__*/_jsxs(CUIFlex, {
      direction: {
        base: 'row',
        md: 'row'
      },
      align: "center",
      width: "100%",
      justify: "space-between",
      children: [/*#__PURE__*/_jsxs(CUILink, {
        href: buildLink(),
        onClick: () => trackInteraction('click header nav logo'),
        order: {
          base: 0,
          md: 0
        },
        maxW: {
          base: '100%',
          sm: '180px'
        },
        children: [/*#__PURE__*/_jsx(CUIConnectLogo, {
          alt: "Visit Connect.com homepage",
          width: "100%",
          display: {
            base: 'none',
            sm: 'block'
          }
        }), /*#__PURE__*/_jsx(CUIConnectLogo, {
          use: "icon",
          width: "50px",
          display: {
            base: 'block',
            sm: 'none'
          }
        })]
      }), /*#__PURE__*/_jsx(CUIBox, {
        order: {
          base: 2,
          md: 1
        },
        children: /*#__PURE__*/_jsx(HomepageHeaderNav, {})
      }), /*#__PURE__*/_jsx(LoginSignupButtons, {
        order: {
          base: 1,
          md: 2
        },
        display: {
          base: 'none',
          md: 'block'
        },
        py: {
          base: 4,
          md: 0
        },
        trackingIdentifier: "navigation-bar"
      })]
    }), /*#__PURE__*/_jsx(CUIFlex, {
      marginTop: 6,
      maxW: "830px",
      ml: "auto",
      mr: "auto",
      children: children
    })]
  });
};

export default HomepageHeader;